module.exports = __webpack_public_path__ + "static/media/logo_white.55271a48.svg";